import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { setClass } from '../../helpers/utils';
import { alertActions } from '../../redux/actions/alertActions';
import { Close } from '../Icons/Close';
import './styles.scss';

type AlertProps = { className?: string };

export const Alert = ({ className = '' }: AlertProps) => {
	const typeVariant = {
		success: 'is-success',
		warning: 'is-warning',
		danger: 'is-danger',
		info: 'is-info',
	};

	const dispatch = useDispatch();
	const { ialert } = useSelector((state) => state.ui);
	const isVariant = typeVariant[ialert.payload?.variant] || 'is-success';

	const handleClose = () => {
		dispatch(alertActions.remove());
	};

	useEffect(() => {
		if (ialert.show) {
			setTimeout(() => {
				handleClose();
			}, 6000);
		}
	}, [ialert.show]);

	return (
		<div
			className={setClass(
				`alert ${isVariant} ${ialert.show && 'is-show'} ${className}`,
			)}
		>
			<div className="alert__content">
				<div className="alert__subcontent">
					<div>
						<span className="alert__title">{ialert.payload?.title}</span>
						<div className="alert__text">{ialert.payload?.message}</div>
					</div>
				</div>
				<div className="alert__close" onClick={handleClose}>
					<Close size={24} />
				</div>
			</div>
		</div>
	);
};
